<div class="column activity-container">
    <div class="row margin-30px" *ngIf="classDetail">
        <img width="20%" height="150px" *ngIf="classDetail.ImageData"
            [src]="classDetail.ImageData? 'data:image/png;base64,' + classDetail.ImageData : 'data:image/png;base64,' + classDetail.bannerImage" />
        <section class="class-info__detail" [ngClass]="{'w-100 ms-0' : !classDetail.ImageData}">
            <div class="class-info__detail--header">
                <div class="class-info__detail--header-left">
                    <h1 class="class-info__detail__name">{{classDetail.LessonName}}</h1>
                    <div class="class-info__detail__location">
                        <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
                        &nbsp;<span>{{classDetail.LocationName}}</span>
                    </div>
                </div>
                <div class="class-info__detail--header-right" *ngIf="classDetail.BaseRate">
                    <label for="rate" class="class-info__detail__rate-label">{{'Startingfrom' | translate}}</label>
                    <div class="class-info__detail__rate-value">{{operatingCurrency}} {{classDetail.BaseRate | currencyDecimalFormatter}}</div>
                </div>
            </div>
            <div class="class-info__detail--content">
                <div class="class-info__detail__item">
                    <label for="start-date" class="class-info__detail__item--label">{{'StartDate' | translate}}</label>
                    <div class="class-info__detail__item--value">{{classDetail.StartDate | localizeDate:'L'}}</div>
                </div>
                <div class="class-info__detail__item">
                    <label for="endDate" class="class-info__detail__item--label">{{'EndDate' | translate}}</label>
                    <div class="class-info__detail__item--value">{{classDetail.EndDate | localizeDate:'L'}}</div>
                </div>
                <div class="class-info__detail__item class-info__detail__item_last">
                    <label for="instructor" class="class-info__detail__item--label">{{'Instructor' | translate}}</label>
                    <div class="class-info__detail__item--value">{{classDetail.Staffs}}</div>
                </div>
            </div>
        </section>
    </div>

    <div class="activity___selector_content">
        <div class="row m-0 activity-selector">
            <div class="reservation-pannel col-lg-5 col-md-5 column">

                <div class="instructor row">
                    <div class="dy-date-picker col-lg-5 col-md-5">
                        <dynamic-form [config]="reservationConfig" #form="dynamicForm">
                        </dynamic-form>
                    </div>
                    <div class="dy-date-picker col-lg-5 col-md-5">
                        <dynamic-form [config]="locationConfig" #form="dynamicForm">
                        </dynamic-form>
                    </div>
                </div>
                <div class="date-field">
                    <div class="txt-bold">
                        {{'SelectDates' | translate}}
                    </div>
                    <div class="row">
                        <div class="dy-date-picker col-lg-5 col-md-5">
                            <dynamic-form [config]="from_dateConfig" #form="dynamicForm">
                            </dynamic-form>
                        </div>
                        <div class="dy-date-picker col-lg-5 col-md-5">
                            <dynamic-form [config]="to_dateConfig" #form="dynamicForm">
                            </dynamic-form>
                        </div>
                    </div>
                </div>
                <div class="cover-size-field">
                    <div class="txt-bold">
                        {{'SelectCoverSize' | translate}}
                    </div>
                    <div class="txt-sub-title">
                        {{'NoofStudents' | translate}}
                    </div>
                    <div class="stu-count">
                        <div class="count">
                            <dynamic-form [config]="customizeSizeConfig" #form="dynamicForm">
                            </dynamic-form>
                            <span class="custom-error" *ngIf="!validGroupSize">{{'MisMatchGroupSizeWithClass' | translate}}</span>
                        </div>
                        <!-- <div class="note">
                            {{'minimumsize' | translate}} ( <span> {{minSizeAllowed}} </span>)
                        </div> -->
                    </div>
                    <div class="booking-type" *ngIf="bookingTypeConfig && bookingTypeConfig.length">
                        <div class="txt-bold">
                            {{'SelectBookingTypes' | translate}}
                        </div>
                        <div class="bookingtypes-list col-lg-5 col-md-5">
                            <dynamic-form [config]="bookingTypeConfig" #form="dynamicForm">
                            </dynamic-form>
                            <span class="custom-error" *ngIf="!validBookingTypes">{{'MisMatchBookingTypeWithBookingSize'
                                |
                                translate}}</span>
                        </div>
                    </div>
                    <div class="cover-type" *ngIf="coverTypeConfig && coverTypeConfig.length">
                        <div class="txt-bold">
                            {{'SelectCoverTypes' | translate}}
                        </div>
                        <div class="cover-list col-lg-5 col-md-5">
                            <dynamic-form [config]="coverTypeConfig" #form="dynamicForm">
                            </dynamic-form>
                            <span class="custom-error" *ngIf="!validCoverTypes">{{'MisMatchCoverTypeWithBookingSize' |
                                translate}}</span>
                        </div>
                    </div>

                </div>

            </div>
            <div class="slots col-lg-5 col-md-5" *ngIf="showSessionorSlots">

                <div class="activity-booking__slot-date column" *ngIf="isSessionClass 
        && SessionSlotsAvailableDates && SessionSlotsAvailableDates.length 
        && SessionSlotsAvailableDates[selectedIndex].AvailableSessions 
        && SessionSlotsAvailableDates[selectedIndex].AvailableSessions.length">
                    <span class="icon icon-Left-Arrow" [class.disabled]="selectedIndex === 0"
                        (click)="navClick(-1)"></span>
                    {{SessionSlotsAvailableDates[selectedIndex].AvailableDate | localizeDate : 'DD MMMM, ddd'}}
                    <span class="icon icon-Right-Arrow"
                        [class.disabled]="selectedIndex === (SessionSlotsAvailableDates.length - 1)"
                        (click)="navClick(1)"></span>
                    <div class="activity-booking__select-slot-label">
                        {{'AvailableTime' | translate}}
                    </div>
                    <ng-container>
                        <div *ngFor="let sessionSlot of SessionSlotsAvailableDates; let index = index;"
                            class="activity-booking__slots-holder" [class.active]="selectedIndex === index">
                            <app-activity-slot-view [SessionSlots]="sessionSlot.AvailableSessions"
                                [isMultiSlotSelection]="isMultiSlotSelection" (slotClick)="slotChangeListners($event)"
                                [MembershipId]="activityService.membershipId"
                                [AllocationTypes]="activityService.AllocationTypes">
                            </app-activity-slot-view>
                        </div>
                    </ng-container>

                </div>
                <mat-checkbox *ngIf="isSessionClass 
                && SessionSlotsAvailableDates && SessionSlotsAvailableDates.length 
                && SessionSlotsAvailableDates[selectedIndex].AvailableSessions 
                && SessionSlotsAvailableDates[selectedIndex].AvailableSessions.length"
                    (change)="applyToOtherDates(selectedIndex, $event)"> {{'Bookforallavailabledates' | translate}} (
                    <span class="date-text">{{SessionSlotsAvailableDates[0].AvailableDate | localizeDate: 'DD MMMM'}} -
                        {{SessionSlotsAvailableDates[SessionSlotsAvailableDates.length -1].AvailableDate | date:'dd
                        MMMM'}}</span> )
                </mat-checkbox>
                <app-activity-slot-view *ngIf="!isSessionClass && classLessonList && classLessonList.length"
                    [SessionSlots]="classLessonList" [isMultiSlotSelection]="isMultiSlotSelection"
                    (slotClick)="slotChangeListners($event)" [MembershipId]="activityService.membershipId"
                    [AllocationTypes]="activityService.AllocationTypes">
                </app-activity-slot-view>
                <div class="selected-class-schedule"
                    *ngIf="!isSessionClass && selectedClassSchedule && selectedClassSchedule.length">
                    <ng-container *ngFor="let selectedDay of selectedClassSchedule; let index = index;">
                        <div class="selected-class-schedule__row" *ngIf="selectedDay">
                            <div class="selected-class-schedule__day">
                                {{dayOfWeek[index]}}
                            </div>
                            <ul class="selected-class-schedule__session-period-list">
                                <li class="selected-class-schedule__session-period-item"
                                    *ngFor="let slot of selectedDay;">
                                    <span>{{slot.Start | localizeDate: 'LT'}} - {{slot.End | localizeDate: 'LT'}}</span>
                                </li>
                            </ul>
                        </div>
                    </ng-container>
                </div>
                <div class="no-slots-message"
                    *ngIf="(isSessionClass 
        && (!SessionSlotsAvailableDates || (SessionSlotsAvailableDates && SessionSlotsAvailableDates.length === 0 )
        || !SessionSlotsAvailableDates[selectedIndex].AvailableSessions 
        || (SessionSlotsAvailableDates[selectedIndex].AvailableSessions && SessionSlotsAvailableDates[selectedIndex].AvailableSessions.length === 0))) || (!isSessionClass && (!classLessonList || (classLessonList && classLessonList.length === 0)))">
                    {{'noSlotsAvailable' | translate}}
                </div>

            </div>
        </div>
    </div>
    <div class="row button-container pre-next">
        <div class="button-group">
            <div class="d-inline-block button-gap" *ngIf="activityService.operation == Operation.create">
                <app-button [buttontype]="previousButton" (valueChange)="gotoPreviousPage($event)"></app-button>
            </div>
            <div class="d-inline-block button-gap">
                <app-button [buttontype]="nextButton" (valueChange)="gotoNextPage($event)"></app-button>
            </div>
        </div>
    </div>
</div>